import { render, staticRenderFns } from "./LogoLanhuIcon.vue?vue&type=template&id=fa8b4ade&"
import script from "./LogoLanhuIcon.vue?vue&type=script&lang=js&"
export * from "./LogoLanhuIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports